import axios from "axios";
import { misc, liquid } from "./category";
import store from "./store";

export class ImageBlob {
  constructor(file) {
    this.blob = file;
    this.name = file.name;
  }

  get file() {
    return this.blob;
  }

  get filename() {
    return this.name;
  }

  get url() {
    if (this._url) return this._url;
    return (this._url = URL.createObjectURL(this.blob));
  }

  dispose() {
    if (this._url) URL.revokeObjectURL(this._url);
    this._url = this.blob = undefined;
  }
}

export function buildForm(action) {
  const formData = new FormData();
  for (const property of Object.values(store.values)) {
    for (const [key, value] of Object.entries(property)) {
      const fieldValue = key === "logo" ? (value?.url ?? value) : value;
      formData.append(`site_builder[${key}]`, fieldValue || "");
    }
  }
  formData.append("site_builder[user-action]", action);
  return formData;
}

export async function makeRequest(formData) {
  await fetch("/site_builder/submit", {
    method: "POST",
    headers: {
      "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
    },
    body: formData,
  });
}

export function initToast(controller) {
  const getToastController = (type) => {
    const toastElement = document.querySelector(
      `.site-builder-toast.${type}[data-controller]`
    );
    const toastControllerName = toastElement.dataset.controller;

    return controller.application.getControllerForElementAndIdentifier(
      toastElement,
      toastControllerName
    );
  };

  const infoToastController = getToastController("info");
  const errorToastController = getToastController("error");

  Object.assign(controller, {
    toast: {
      info: infoToastController,
      error: errorToastController,
    },
  });
}

export function setLogo() {
  const logoWrappers = document.querySelectorAll(".site-name > a");
  const { logo } = misc.values;
  const logoURL = logo?.url ?? logo;

  if (!logoURL) return;

  const { logo: _, ...rest } = liquid.values;
  liquid.values = rest;

  logoWrappers.forEach((logoWrapper) => {
    const logoImgTag = document.createElement("img");
    logoImgTag.src = logoURL;
    logoWrapper?.replaceChildren(logoImgTag);
  });
}

export function loadFonts(fonts = null) {
  if (!fonts) {
    fonts = [
      "Playfair Display",
      "Raleway",
      "Barlow Condensed",
      "Lora",
      "Yeseva One",
      "Merriweather Sans",
      "Lora",
      "Lato",
      "Belleza",
      "Source Sans Pro",
      "Libre Baskerville",
      "Roboto",
      "Asul",
      "Merriweather",
      "Tenor Sans",
      "Roboto Slab",
      "Open Sans",
      "Crimson Text",
      "Fjord One",
      "Yeseva One",
      "Merriweather Sans",
      "Montserrat",
      "Source Serif Pro",
      "Cardo",
      "Josefin Sans",
      "Oswald",
      "Poppins",
      "PT Sans",
      "EB Garamond",
    ];
  }
  window.WebFont.load({
    google: {
      families: fonts,
    },
  });
}

export const swatches = [
  "#A0AEC0",
  "#F56565",
  "#ED8936",
  "#ECC94B",
  "#48BB78",
  "#38B2AC",
  "#4299E1",
  "#667EEA",
  "#9F7AEA",
  "#ED64A6",
];

export function imageBaseToUrl(imageSet) {
  if (!imageSet) return {};

  const imageSetBase = document.querySelector(
    "[data-site-builder-image-set-prefix]"
  ).dataset.siteBuilderImageSetPrefix;

  return {
    "hero-url": `url("${imageSetBase}/image_sets/${imageSet}/hero.jpg")`,
    "footer-one-url": `url("${imageSetBase}/image_sets/${imageSet}/footer-one.jpg")`,
    "footer-two-url": `url("${imageSetBase}/image_sets/${imageSet}/footer-two.jpg")`,
  };
}

export async function blobToBase64(blobURL) {
  if (!blobURL) return;

  const blob = (
    await axios({ url: blobURL, responseType: "blob", method: "get" })
  ).data;

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

export async function urlToBase64(url) {
  const data = await fetch(url, {
    headers: { "Cache-Control": "no-cache" },
  });
  const blob = await data.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = async () => {
      try {
        const base64data = reader.result;
        resolve(base64data);
      } catch (e) {
        reject(e);
      }
    };
    reader.onerror = reject;
  });
}

export async function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
}

export async function imageDimensions(imageUrl) {
  const img = new Image();

  const promise = new Promise((resolve, reject) => {
    img.onload = () => {
      const width = img.width;
      const height = img.height;

      resolve({ width, height });
    };
    img.onerror = reject;
  });

  img.src = imageUrl;
  return promise;
}

export function navigateWithConfirm(url) {
  const persistenceController =
    window.parent.Stimulus.getControllerForElementAndIdentifier(
      window.parent.document.querySelector(".ctas"),
      "site-builder--persistence"
    );

  let message = `Are you sure you want to leave LawLytics?${persistenceController.allStoresEmpty() ? '' : ' The unsaved changes will be lost.'}`

  if (window.parent.confirm(message)) {
    persistenceController.disconnect();
    top.window.location = url;
  }
}

export function previewSetup() {
  const rootId = document.querySelector('[data-root-id]')?.dataset.rootId
  const pageId = document.querySelector('[data-page-id]')?.dataset.pageId
  const parentId = document.querySelector('[data-parent-id]')?.dataset.parentId

  $('nav #page_' + rootId).parent().addClass('active');
  $('nav #subnav_page_' + pageId).parent().addClass('active');
  $('nav #subnav_page_' + parentId).parent().addClass('active');

  $('#comments article[data-parent-id!=""]').each(function () {
    const comment = $(this);
    const parent = $('#comments article[data-id="' + $(this).data('parent-id') + '"]');
    let children_container = parent.find('> .children_container');
    if (children_container.length === 0) {
      children_container = parent.append('<div class="children_container"></div>').find('> .children_container');
    }
    comment.appendTo(children_container);
    comment.find('.new_comment_reply').remove();
  });

  $('.insertion.image .caption').each(function () {
    // set captions width to that of the inserted img
    const caption = $(this);
    const image = caption.prev('img');
    caption.width(image.width());
  });

  $('.widget.recommendations, .widget.case_results').each(function () {
    $(this).find('span.summary').jTruncate({ length: 120 });
  });


  // -----  embedded videos
  $('div.insertion.video[data-video-url]').each(function () {
    const fv = $(this).flareVideo();
    fv.load([
      {
        src: $(this).data('video-url'),
        type: 'video/mp4'
      },
    ]);
  });

  // Wrapping TinyMCE tables inside ll-table-wrapper
  $('.ll-table').wrap('<div class="ll-table-wrapper"></div>');
}
